<template>
  <div>
    <Link class="group flex items-center py-3 menu-link" href="/bulk-replace">
      <svg
        :class="isUrl('bulk-replace') ? '' : 'icon-disabled'"
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="20px"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#FFFFFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="11" y1="8" x2="11" y2="14" />
        <line x1="8" y1="11" x2="14" y2="11" />
      </svg>
      <div :class="isUrl('bulk-replace') ? 'text-white font-semibold' : 'text-indigo-300 group-hover:text-white'">
        Bulk Replace
      </div>
    </Link>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
  components: { Link },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>

<style>
.icon-disabled {
  opacity: 0.5;
}
.menu-link svg {
  margin-right: 5px;
}
.menu-link {
  font-size: 14px;
}
</style>
